export default {
  'productiveHoursSold.label.filterDate': 'Filter by date',
  'productiveHoursSold.label.status': 'Status',
  'productiveHoursSold.label.reportType': 'Select report type',
  'productiveHoursSold.label.workingDays': 'Working days per month',
  'productiveHoursSold.label.hoursWorked': 'Hours worked per day',
  'productiveHoursSold.label.moreOptions': 'More options',
  'productiveHoursSold.label.type': 'Type',
  'productiveHoursSold.label.employees': 'Employees',
  'productiveHoursSold.label.area': 'Area',

  'productiveHoursSold.option.input': 'Input',
  'productiveHoursSold.option.authorization': 'Authorization',
  'productiveHoursSold.option.closure': 'Closure',
  'productiveHoursSold.option.exit': 'Exit',
  'productiveHoursSold.option.open': 'Open',
  'productiveHoursSold.option.authorized': 'Authorized',
  'productiveHoursSold.option.closed': 'Closed',
  'productiveHoursSold.option.canceled': 'Canceled',
  'productiveHoursSold.option.perEmployee': 'Per Employee',
  'productiveHoursSold.option.byArea': 'By Area',
  'productiveHoursSold.option.budget': 'Budget',
  'productiveHoursSold.option.warranty': 'Warranty',
  'productiveHoursSold.option.return': 'Return',
  'productiveHoursSold.option.courtesy': 'Courtesy',
  'productiveHoursSold.option.insideCourtesy': 'Inside (Courtesy)',
  'productiveHoursSold.option.totalLoss': 'Total Loss',
  'productiveHoursSold.option.revision': 'Revision',

  'productiveHoursSold.checkbox.inhibitArea':
    'inhibit average area and report values',
  'productiveHoursSold.checkbox.viewModel':
    'view vehicle model and version in report',
};
